// extracted by mini-css-extract-plugin
export default {"page":"myAccount_page__seVrb","pageHeader":"myAccount_pageHeader__H71P7"};